import React, { Component } from "react"
import { Container, Row, Col } from "reactstrap"
import styled from "styled-components"
import ReactHtmlParser from "react-html-parser"
import { GatsbyImage } from "gatsby-plugin-image";
import { media } from "utils/Media"
import WPLink from "components/shared/WPLink"
import BlockTitle from "components/shared/BlockTitle"

const ImgStyled = styled(GatsbyImage)`
    min-width: 130px;

    @media ${media.sm} {
        min-width: 250px;
    }
`

class HorizontalImageText extends Component {
    render() {
        const { block } = this.props

        return (
            <Container className="py-4">
                <Row>
                    <Col>
                        {block.image &&
                            <ImgStyled image={block.image.localFile.childImageSharp.gatsbyImageData} alt={block.image.altText} className="mb-2 ml-0 mr-4 float-sm-left" />
                        }
                        {block.title && 
                            <BlockTitle className="pt-0">{block.title}</BlockTitle>
                        }
                        {block.text &&
                            ReactHtmlParser(block.text)
                        }
                    </Col>
                </Row>
                {block.link &&
                    <Row>
                        <Col className="pt-3">
                            <WPLink url={block.link.url} target={block.link.target} button>
                                {block.link.title}
                            </WPLink>
                        </Col>
                    </Row>
                }
            </Container>
        );
    }
}

export default HorizontalImageText